/* iceberg-ui */
import { Checklist, Flex } from '@auviknetworks/iceberg-ui';

/* Images  */
import PictographPrimaryOneColorLightPurple from 'images/pictograph/SVG/pictograph-primary-oneColor-lightPurple.svg';

/*  React  */
import React from 'react';
import { withTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const ListOfItems = ({ t }) => [
    t('Onboarding.quickScanChecklist.setupIntegration'),
    t('Onboarding.quickScanChecklist.chooseConfigure'),
    t('Onboarding.quickScanChecklist.groupScanSettings'),
    t('Onboarding.quickScanChecklist.clientProfileReady')
];

export const QuickScanChecklist = withTranslation()(
    ({ MotionWrapper, stepNumberMap, t }) => {
        const { currentStep } = useParams();
        return (
            <>
                <Flex
                    data-testid="onboardingQuickScanChecklistStepImg"
                    justifyContent="center"
                    maxHeight="65%"
                    width="100%"
                >
                    <MotionWrapper key="onboardingQuickScanChecklistStepMW">
                        <img
                            src={PictographPrimaryOneColorLightPurple}
                            alt={t('Pictograph.primaryLightPurple')}
                            width="240px"
                            data-testid="logoCloseUpImage"
                        />
                    </MotionWrapper>
                </Flex>
                <Flex
                    alignItems="center"
                    data-testid="onboardingQuickScanChecklistStep"
                    flexDirection="column"
                    mt={5}
                    mx="4%"
                >
                    <Checklist
                        currentItem={stepNumberMap[currentStep] - 1}
                        listItems={ListOfItems({ t })}
                        showSeparation
                        title={t('Onboarding.quickScanChecklist.title')}
                        cardHeaderProps={{
                            style: { textTransform: 'capitalize' }
                        }}
                    />
                </Flex>
            </>
        );
    }
);
